import type { CreateClientConfig } from '@/client/client.gen'
import { env } from '@/config/env'
import { fetchWithSession } from '@ventawiz/web-kit'

/**
 * Runtime configuration for the generated client.
 *
 * `@hey-api/openapi-ts` points the generated `client.gen.ts` at this file, so
 * the generated code never has to be edited to change a host or a header —
 * which is what makes "never edit `src/client/` by hand" a rule anyone can
 * actually follow.
 *
 * The `override` is spread first and our values second: the generator passes
 * defaults derived from the schema, and dropping them would silently discard
 * the server URL it read from the document.
 *
 * `fetchWithSession` comes from `@ventawiz/web-kit` — it attaches the access
 * token and refreshes once on a 401. It is shared rather than written here
 * because every VentaWiz app needs exactly that behaviour, and a divergence in
 * it is a session bug nobody would see until a token expired in production.
 */
export const createClientConfig: CreateClientConfig = (override) => ({
  ...override,
  baseUrl: env.apiBaseUrl || '/',
  // The API itself is stateless and takes a bearer token, but the same origin
  // serves the auth service under /auth, whose refresh cookie must ride along.
  credentials: 'include',
  fetch: fetchWithSession,
})
